<template>
<span>{{value}}</span>
</template>

<script>
import moment from 'moment'
import 'moment-duration-format'

export default {
	name: "JmDuration",

	props: {
		content: [ String, Number, Object ]
	},

	computed: {
		value () {
			return moment.duration(this.content).format("hh:mm", {trim: false});
		}
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Duration.vue